import { FileText, Download, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GUIDES = [
    {
        key: "guide-clients",
        title: "Guide clients",
        subtitle:
            "Comment utiliser Carvaelis pour faire convoyer vos véhicules en toute sécurité.",
        pages: 6,
        size: "17 Ko",
        badge: "Clients",
    },
    {
        key: "guide-plateforme",
        title: "Guide plateforme",
        subtitle:
            "Votre espace en ligne pour piloter vos convoyages en toute sérénité.",
        pages: 6,
        size: "16 Ko",
        badge: "Plateforme",
    },
    {
        key: "guide-convoyeur",
        title: "Guide convoyeur",
        subtitle:
            "Procédure officielle pour les convoyeurs Carvaelis certifiés.",
        pages: 6,
        size: "17 Ko",
        badge: "Convoyeurs",
    },
];

export default function GuidesDownload() {
    return (
        <section
            id="guides"
            data-testid="guides-section"
            className="section-y bg-white border-y border-slate-200"
        >
            <div className="container-x">
                <div className="grid lg:grid-cols-12 gap-10 mb-14 items-end">
                    <div className="lg:col-span-7">
                        <p className="text-xs uppercase tracking-[0.2em] text-signal font-bold mb-4">
                            — Ressources
                        </p>
                        <h2 className="font-display font-black tracking-tighter text-ink text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
                            Guides à
                            <br />
                            <span className="italic font-medium">
                                télécharger.
                            </span>
                        </h2>
                    </div>
                    <div className="lg:col-span-4 lg:col-start-9">
                        <p className="text-base text-slate-600 leading-relaxed">
                            Nos documentations officielles pour prendre en
                            main Carvaelis, que vous soyez client ou
                            convoyeur.
                        </p>
                    </div>
                </div>

                <div className="grid md:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
                    {GUIDES.map((g, i) => (
                        <a
                            key={g.key}
                            href={`${API}/guides/${g.key}`}
                            download
                            data-testid={`guide-download-${g.key}`}
                            className="group bg-white p-8 lg:p-10 flex flex-col hover:bg-ink transition-colors duration-500 relative"
                        >
                            <div className="flex items-center justify-between mb-8">
                                <div className="w-12 h-12 bg-signal flex items-center justify-center group-hover:scale-110 transition-transform">
                                    <FileText
                                        className="w-6 h-6 text-white"
                                        strokeWidth={1.75}
                                    />
                                </div>
                                <span className="text-[10px] uppercase tracking-widest font-bold text-slate-400 group-hover:text-signal border border-slate-200 group-hover:border-signal px-2 py-1 transition-colors">
                                    PDF
                                </span>
                            </div>

                            <span className="text-[10px] uppercase tracking-widest font-bold text-signal mb-3">
                                {g.badge}
                            </span>
                            <h3 className="font-display font-black text-2xl sm:text-3xl tracking-tighter text-ink group-hover:text-white transition-colors mb-3 leading-tight">
                                {g.title}
                            </h3>
                            <p className="text-sm text-slate-600 group-hover:text-white/70 transition-colors leading-relaxed flex-1 mb-8">
                                {g.subtitle}
                            </p>

                            <div className="flex items-center justify-between border-t border-slate-100 group-hover:border-white/10 pt-5 transition-colors">
                                <div className="text-[11px] uppercase tracking-wider text-slate-500 group-hover:text-white/50 transition-colors">
                                    {g.pages} pages · {g.size}
                                </div>
                                <div className="flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-ink group-hover:text-signal transition-colors">
                                    <Download className="w-4 h-4" />
                                    <ArrowRight className="w-4 h-4 -translate-x-2 opacity-0 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
